import { Routes, Route } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard';
import { MainLayout } from './components/layout/MainLayout';
import { DashboardPage } from './pages/DashboardPage';
import { QueuePage } from './pages/QueuePage';
import { PerformancePage } from './pages/PerformancePage';
import { DeliveryPage } from './pages/DeliveryPage';
import { SigningPage } from './pages/SigningPage';
import { SealsPage } from './pages/SealsPage';
import { OrganisationsPage } from './pages/OrganisationsPage';
import { HealthPage } from './pages/HealthPage';
import { UsersPage } from './pages/UsersPage';
import { EmailTemplatesPage } from './pages/EmailTemplatesPage';
import { CertificateTemplatesPage } from './pages/CertificateTemplatesPage';
import { AlertingPage } from './pages/AlertingPage';
import { IssuanceTestPage } from './pages/IssuanceTestPage';

export default function App() {
  return (
    <AuthGuard>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/queue" element={<QueuePage />} />
          <Route path="/performance" element={<PerformancePage />} />
          <Route path="/delivery" element={<DeliveryPage />} />
          <Route path="/signing" element={<SigningPage />} />
          <Route path="/seals" element={<SealsPage />} />
          <Route path="/email-templates" element={<EmailTemplatesPage />} />
          <Route path="/certificate-templates" element={<CertificateTemplatesPage />} />
          <Route path="/organisations" element={<OrganisationsPage />} />
          <Route path="/issuance-test" element={<IssuanceTestPage />} />
          <Route path="/health" element={<HealthPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/alerting" element={<AlertingPage />} />
        </Route>
      </Routes>
    </AuthGuard>
  );
}
